import Vue from 'vue'
export const formBus = new Vue({})
